export default {
  getUsers (state) {
    return state.users
  },
  getUserById (state) {
    return id => state.users.find(item => { return Number(item.id) === Number(id) })
  },
  getUserByEmail (state) {
    return email => state.users.find(item => { return item.email.toLowerCase() === email.toLowerCase() })
  },
  getRoles (state) {
    return state.roles
  },
  getRoleById (state) {
    return id => state.roles.find(item => { return Number(item.id) === Number(id) })
  },
  getProjects (state) {
    return state.projects
  },
  getProjectById (state) {
    return id => state.projects.find(item => { return Number(item.id) === Number(id) })
  },
  getProjectByUuid (state) {
    return uuid => state.projects.find(item => { return item.uuid === uuid })
  },
  getGNIPRules (state) {
    return state.gnipRules
  },
  getTheme (state) {
    return state.theme
  }
}



// WEBPACK FOOTER //
// ./src/store/getters.js